<div class="bg-[#FFF] rounded-[10px]" [ngClass]="{ 'w-full': isFromVault, 'w-[650px]': !isFromVault }">
  @if(!isFromVault) {
  <div class="title-bar">
    <div class="title-text">Add Entity Vault</div>
    <div class="pointer" (click)="closeModel()"><mat-icon>close</mat-icon></div>
  </div>
  }

  <form #userForm="ngForm">
    <div [ngClass]="{ 'p-[24px]': !isFromVault, 'mt-[12px]': isFromVault }">
      <div class="flex fl-col gap-[12px] w-full">
        <div class="w-full">
          <mat-form-field appearance="fill" floatLabel="auto" class="login-signup-form-desing w-full">
            <mat-label class="automtic-form-desing-lable pl-1">
              @if(setEntityNameSuggestion === entityName && entityName != ''){
              <img matPrefix src="assets/images/ai_suggestion_small.svg" alt="Entity Icon" />
              } Entity Name
            </mat-label>

            <input
              matInput
              name="name"
              #name
              required
              [(ngModel)]="entityName"
              type="text"
              [ngClass]="{ 'ml-[16px]': setEntityNameSuggestion === entityName && entityName != '' }"
              (ngModelChange)="entityNameChange()"
            />
          </mat-form-field>
        </div>
      </div>
      <mat-form-field class="login-signup-form-desing w-full mt-6" floatLabel="never">
        <mat-label class="automtic-form-desing-lable pl-1">
          @if( ai_suggested_entity != '' && ai_suggested_entity.id == myControl.value){
          <img matPrefix src="assets/images/ai_suggestion_small.svg" alt="Entity Icon" />
          } Entity Type
        </mat-label>
        <mat-select
          #templateSelect
          class="transaction__select--form--field"
          [ngClass]="{ 'pl-[16px]': ai_suggested_entity != '' && ai_suggested_entity.id == myControl.value }"
          placeholder="Type"
          [formControl]="myControl"
        >
          @if(ai_suggested_entity != ''){
          <mat-option [value]="ai_suggested_entity?.id" (click)="selectEntityType(ai_suggested_entity)">
            <div class="flex fl-al-center gap-[8px]">
              <div class="h-[40px] w-[40px] flex-center bg-[#EBF0FA] rounded-lg flex-center">
                <img class="h-[40px] w-[40px]" [src]="'assets/images/ai_suggestion.svg'" />
              </div>
              <div>
                <p class="m-0" style="position: relative; top: 3px">
                  {{ ai_suggested_entity.type }}
                </p>
                <img style="width: 124px" src="assets/images/ai_suggestion_text.svg" />
              </div>
            </div>
          </mat-option>
          }
          <ng-container *ngFor="let option of options">
            @if(ai_suggested_entity === '' || ai_suggested_entity.id != option.id){
            <mat-option [value]="option.type" (click)="selectEntityType(option)">
              <div class="flex fl-al-center gap-[8px]">
                <div class="h-[40px] w-[40px] flex-center bg-[#EBF0FA] rounded-lg flex-center">
                  <img class="h-[40px] w-[40px]" [src]="option.image ? option.image : 'assets/images/vault_setup/entityVaultIcon.svg'" />
                </div>
                <div>{{ option.type }}</div>
              </div>
            </mat-option>
            }
          </ng-container>
        </mat-select>
      </mat-form-field>

      <!-- <div *ngIf="true" class="w-full" [ngClass]="{ 'mt-[10px]': !isFromVault, 'mt-[12px]': isFromVault }">
        <mat-form-field appearance="fill" class="automtic-form-desing-form-only entity-form-select w-full">
          <mat-label *ngIf="!hideSuffix" class="automtic-form-desing-lable entity-label">
              @if( ai_suggested_entity != '' && ai_suggested_entity.id == selectedEntityType.id){
              <img matPrefix src="assets/images/ai_suggestion_small.svg" alt="Entity Icon" />
              } Entity Type</mat-label
          >
          <input
            #entityInput
            required
            type="text"
            matInput
            [formControl]="myControl"
            [ngClass]="{ 'ml-[16px]': ai_suggested_entity != '' && ai_suggested_entity.id == selectedEntityType?.id }"
            [matAutocomplete]="auto"
            (focus)="toggleSuffix(true)"
            (blur)="toggleSuffix(false)"
            placeholder="Search Entity Type"
            name="entityType"
            [(ngModel)]="entityType"
          />
          <span *ngIf="hideSuffix" matPrefix class="matPrefix-search-icon ml-[24px] mr-[8px] text-[#25508E]"
            ><img src="../../../../assets/images/search-blue.svg" width="20px" height="19px"
          /></span>
          <span *ngIf="!hideSuffix" matSuffix class="cursor-pointer material-icons pr-2 text-[#25508E]">expand_more</span>
          <span *ngIf="hideSuffix" (click)="clearValue($event)" matSuffix class="cursor-pointer material-icons pr-2 text-[#898F9E]">close</span>

          <mat-autocomplete #auto="matAutocomplete" name="entityType">
            @if(ai_suggested_entity != ''){
            <mat-option [value]="ai_suggested_entity?.type" (onSelectionChange)="selectEntityType(ai_suggested_entity)">
              <div class="flex fl-al-center gap-[8px]">
                <div class="h-[40px] w-[40px] flex-center bg-[#EBF0FA] rounded-lg flex-center">
                  <img class="h-[40px] w-[40px]" [src]="'assets/images/ai_suggestion.svg'" />
                </div>
                <div>
                  <p class="m-0" style="position: relative; top: 3px">
                    {{ ai_suggested_entity.type }}
                  </p>
                  <img src="assets/images/ai_suggestion_text.svg" style="width: 124px" />
                </div>
              </div>
            </mat-option>
            }
            <ng-container *ngFor="let option of filteredOptions | async">
              @if(ai_suggested_entity === '' || ai_suggested_entity.id != option.id){
              <mat-option [value]="option.type" (onSelectionChange)="selectEntityType(option)">
                <div class="flex fl-al-center gap-[8px]">
                  <div class="h-[40px] w-[40px] flex-center bg-[#EBF0FA] rounded-lg flex-center">
                    <img class="h-[40px] w-[40px]" [src]="option.image ? option.image : 'assets/images/vault_setup/entityVaultIcon.svg'" />
                  </div>
                  <div>{{ option.type }}</div>
                </div>
              </mat-option>
              }
            </ng-container>
          </mat-autocomplete>
        </mat-form-field>
      </div> -->
    </div>

    @if(!isFromVault) {
    <div class="px-[20px] pb-[24px]">
      <div
        [ngClass]="{ 'bg-[#C1C2C5]': !entityName || !entityType, 'bg-[#25508E]': entityName && entityType }"
        class="flex-center rounded-lg h-[48px] w-full text-[#FFFFFF] font-open-sans text-base font-semibold pointer"
        (click)="createVault()"
      >
        Save
      </div>
    </div>
    }
  </form>
  @if (formData?.length) {
  <div style="display: none">
    <edit-template-basic-form [Form1]="formData" [documentForm]="documentForm"> </edit-template-basic-form>
  </div>
  }
</div>
